import { CreateWorkspace } from "common/components/CreateWorkspace/index";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import type { ReactNode } from "react";

interface CreateWorkspaceModalProps {
  triggerButton: ReactNode;
}

export default function CreateWorkspaceModal({
  triggerButton,
}: CreateWorkspaceModalProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Trigger = isDesktop ? DialogTrigger : DrawerTrigger;

  return (
    <Component>
      <Trigger asChild>{triggerButton}</Trigger>
      <Content className="lg:w-[448px]">
        <CreateWorkspace isDialog />
      </Content>
    </Component>
  );
}
